import { useState } from 'react';
import BasicMenu from './BasicMenu';
import { isValidDate } from '../../../utils/functions';
import { useCategory } from '../../../CategoryContext';

const getReadableTextColor = (hex) => {
  if (!hex || typeof hex !== 'string') return 'white';
  const value = hex.replace('#', '');
  if (value.length !== 6) return 'white';
  const r = parseInt(value.substring(0, 2), 16);
  const g = parseInt(value.substring(2, 4), 16);
  const b = parseInt(value.substring(4, 6), 16);
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return luminance > 0.6 ? 'black' : 'white';
};

const Task = ({
  title,
  deadline,
  details,
  isCompleted,
  deleteHandler,
  toggleHandler,
  editHandler,
  associatedVerticalId,
  tagColor,
  isVertical,
  assignedTo,
  assignedBy,
  createdAt,
  copyToPersonalHandler,
  canManage = true,
}) => {
  const { verticals } = useCategory();
  const associatedVertical = associatedVerticalId
    ? (verticals || []).find((v) => v.id === associatedVerticalId)
    : null;
  const [expanded, setExpanded] = useState(false);

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const taskDate = new Date(deadline);
  taskDate.setHours(0, 0, 0, 0);

  const dynamicColor = taskDate < today ? '#DB4D4D' : taskDate > today ? '#4CAF50' : '#FAC249';
  const textColor = dynamicColor === '#DB4D4D' || dynamicColor === '#4CAF50' ? 'white' : 'black';

  function formatDate(date) {
    if (!isValidDate(new Date(date))) return '';

    const today = new Date();
    const taskDate = new Date(date);

    // Remove time portion for accurate date comparison
    today.setHours(0, 0, 0, 0);
    taskDate.setHours(0, 0, 0, 0);

    if (taskDate.getTime() === today.getTime()) {
      return 'Today';
    } else if (taskDate.getTime() === today.getTime() + 86400000) {
      return 'Tomorrow';
    } else {
      return taskDate.toLocaleDateString({
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
      });
    }
  }

  return (
    <div className="task-item">
      <div className="task-header">
        <div style={{ display: 'flex', gap: '5px', alignContent: 'center' }}>
          <input
            type="checkbox"
            className="task-radio"
            onClick={(e) => {
              e.stopPropagation();
              if (!canManage) return;
              toggleHandler();
            }}
            checked={isCompleted}
            readOnly={!canManage}
            disabled={!canManage}
          />

          <p
            style={{
              marginBottom: 0,
              marginTop: 3,
              padding: 0,
              fontSize: '16px',
              fontWeight: 500,
              color: 'black',
              textDecoration: isCompleted ? 'line-through' : 'none',
            }}
          >
            {title}
          </p>
        </div>

        {canManage && (
          <div onClick={(e) => e.stopPropagation()}>
            <BasicMenu
              deleteHandler={deleteHandler}
              editHandler={editHandler}
              copyToPersonalHandler={copyToPersonalHandler}
            />
          </div>
        )}
      </div>
      <div className="task-footer">
        {deadline && (
          <button
            className="task-date"
            style={{
              backgroundColor: dynamicColor,
              color: textColor,
            }}
          >
            {formatDate(deadline)}
          </button>
        )}

        {associatedVertical && (
          <button
            className="task-date"
            style={{
              backgroundColor: tagColor || '#356AC3',
              color: getReadableTextColor(tagColor || '#356AC3'),
              marginLeft: deadline ? '8px' : 0,
            }}
          >
            Vertical: {associatedVertical.name}
          </button>
        )}

        {isVertical && (assignedTo || assignedBy || createdAt) && (
          <span
            style={{
              marginLeft: '12px',
              fontSize: '13px',
              color: '#475467',
              display: 'inline-flex',
              gap: '16px',
              alignItems: 'center',
            }}
          >
            {assignedTo && (
              <span>
                <span style={{ fontWeight: 600 }}>Assigned To:</span> {assignedTo}
              </span>
            )}
            {assignedBy && (
              <span>
                <span style={{ fontWeight: 600 }}>Created By:</span> {assignedBy}
              </span>
            )}
            {createdAt && isValidDate(new Date(createdAt)) && (
              <span>
                <span style={{ fontWeight: 600 }}>Created On:</span>{' '}
                {new Date(createdAt).toLocaleDateString('en-US', {
                  year: 'numeric',
                  month: 'numeric',
                  day: 'numeric',
                })}
              </span>
            )}
          </span>
        )}

        {details && (
          <p
            style={{
              marginTop: 10,
              marginBottom: 0,
              color: 'black',
              textDecoration: isCompleted ? 'line-through' : 'none',
              whiteSpace: 'pre-wrap',
            }}
          >
            {expanded ? details : details.length > 280 ? `${details.slice(0, 280)}...` : details}

            {details.length > 280 && (
              <span
                onClick={(e) => {
                  e.stopPropagation();
                  setExpanded(!expanded);
                }}
                style={{
                  background: 'none',
                  border: 'none',
                  color: 'blue',
                  cursor: 'pointer',
                  padding: '5px 0',
                  marginLeft: '5px',
                  display: 'inline',
                  fontSize: '14px',
                }}
                onMouseEnter={(e) => (e.target.style.color = 'darkblue')}
                onMouseLeave={(e) => (e.target.style.color = 'blue')}
              >
                {expanded ? 'Collapse' : 'Expand'}
              </span>
            )}
          </p>
        )}
      </div>
    </div>
  );
};

export default Task;
